/* @flow */

import clsx from 'clsx';
import * as React from 'react';

import { Theme, type ThemeType } from '../../helpers/ui/theme';
import './DebugPicto.css';

export type DebugPictoPropType = {
  +isEnabled: boolean,
  +theme?: ThemeType,
};

const DebugPicto = ({ isEnabled, theme = Theme.Dark }: DebugPictoPropType): React.Node => {
  const [animationState, setAnimationState] = React.useState<'idle' | 'visible' | 'hidden'>(isEnabled ? 'visible' : 'idle');

  React.useEffect(() => {
    if (isEnabled) {
      setAnimationState('visible');
    } else if (animationState === 'visible') {
      // Only transition to 'hidden' if it was previously 'visible'
      setAnimationState('hidden');
    }
  }, [isEnabled]);

  return (
    <svg className={clsx('debugPicto', theme, animationState)} viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8,2.5C6.6,2.5,5.5,3.6,5.5,5h5C10.5,3.6,9.4,2.5,8,2.5z M13,8.5h-1V7.4l0.7-0.7c0.4-0.4,0.4-1,0-1.4 s-1-0.4-1.4,0L10.6,6H5.4L4.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L4,7.4v1.1H3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h1.1 c0,0.3,0.1,0.6,0.2,0.8l-1,1c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0L5.4,13C6.1,13.6,7,14,8,14s1.9-0.4,2.6-1l0.7,0.7 c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-1-1c0.1-0.3,0.2-0.5,0.2-0.8H13c0.6,0,1-0.4,1-1 C14,8.9,13.6,8.5,13,8.5z' />
    </svg>
  );
};

export default DebugPicto;
